// Universal subscription endpoints. Region-agnostic.
import { apiFetch } from './client';

export const checkSubscriptionStatus = (route, tier, token) =>
  apiFetch(
    `/api/subscriptions/status?route=${encodeURIComponent(route)}&tier=${encodeURIComponent(tier)}`,
    { token }
  );